import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DndModule } from 'ngx-drag-drop';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';

import { CreateAccountModalComponent } from './components/account/create-account-modal/create-account-modal.component';
import { AddressComponent } from './components/address/address.component';
import { CardOnFileDropdownComponent } from './components/card-on-file-dropdown/card-on-file-dropdown.component';
import { EditClaimStatusRoutingModalComponent } from './components/claim-status-routing/edit-claim-status-routing-modal/edit-claim-status-routing-modal.component';
import { ClaimPanelComponent } from './components/claim/claim-panel/claim-panel.component';
import { ClaimsPanelSelectComponent } from './components/claim/claims-panel-select/claims-panel-select.component';
import { ContactComponent } from './components/contact/contact.component';
import { CheckboxComponent } from './components/controls/checkbox/checkbox.component';
import { ClaimFilingIndicatorsSelectComponent } from './components/controls/claim-filing-indicators-select/claim-filing-indicators-select.component';
import { DatepickerComponent } from './components/controls/datepicker/datepicker.component';
import { QualifiersComponent } from './components/controls/qualifiers/qualifiers.component';
import { RadioComponent } from './components/controls/radio/radio.component';
import { StatesSelectComponent } from './components/controls/states-select/states-select.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { EraFileInfoModalComponent } from './components/era/era-file-info-modal/era-file-info-modal.component';
import { AddQuickFiltersModalComponent } from './components/filters/add-quick-filters-modal/add-quick-filters-modal.component';
import { FilterItemConfigComponent } from './components/filters/filter-item-config/filter-item-config.component';
import { FiltersComponent } from './components/filters/filters.component';
import { DropdownFilterItemComponent } from './components/filters/grid-item/dropdown-filter-item/dropdown-filter-item.component';
import { ShowlastFilterItemComponent } from './components/filters/grid-item/showlast-filter-item/showlast-filter-item.component';
import { TextboxFilterItemComponent } from './components/filters/grid-item/textbox-filter-item/textbox-filter-item.component';
import { ManageFiltersModalComponent } from './components/filters/manage-filters-modal/manage-filters-modal.component';
import { FinancialsComponent } from './components/financials/financials.component';
import { AddGroupEnrollmentsModalComponent } from './components/group/add-group-enrollments-modal/add-group-enrollments-modal.component';
import { AddIndependantGroupEnrollmentsModalComponent } from './components/group/add-independant-group-enrollments-modal/add-independant-group-enrollments-modal.component';
import { EditGroupEnrollmentCasenumberComponent } from './components/group/edit-group-enrollment-casenumber/edit-group-enrollment-casenumber.component';
import { EditGroupEnrollmentNoteModalComponent } from './components/group/edit-group-enrollment-note-modal/edit-group-enrollment-note-modal.component';
import { EditGroupProcessorComponent } from './components/group/edit-group-processor/edit-group-processor.component';
import { GroupEnrollmentsModalComponent } from './components/group/group-enrollments-modal/group-enrollments-modal.component';
import { GroupEnrollmentsComponent } from './components/group/groups/group-enrollments.component';
import { ViewModifyEnrollmentsModalComponent } from './components/group/view-modify-enrollments-modal/view-modify-enrollments-modal.component';
import { EditInsuranceSetupModalComponent } from './components/insurance/edit-insurance-setup-modal/edit-insurance-setup-modal.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PasswordResetFromComponent } from './components/password-reset-from/password-reset-from.component';
import { EditPayerModalComponent } from './components/payer/edit-payer-modal/edit-payer-modal.component';
import { PracticeManagementDropdownComponent } from './components/practice-management-dropdown/practice-management-dropdown.component';
import { AddProviderSetupModalComponent } from './components/provider/add-provider-setup-modal/add-provider-setup-modal.component';
import { BatchRemittanceComponent } from './components/provider/batch-remittance/batch-remittance.component';
import { CreateProviderGroupModalComponent } from './components/provider/create-provider-group-modal/create-provider-group-modal.component';
import { CreateProviderModalComponent } from './components/provider/create-provider-modal/create-provider-modal.component';
import { EditProviderModalComponent } from './components/provider/edit-provider-modal/edit-provider-modal.component';
import { ProvidersGridComponent } from './components/provider/providers-grid/providers-grid.component';
import { ProvidersGroupGridComponent } from './components/provider/providers-group-grid/providers-group-grid.component';
import { StatusDatesComponent } from './components/provider/status-dates/status-dates.component';
import { QualifiersGridComponent } from './components/qualifiers-grid/qualifiers-grid.component';
import { RecipientinfoComponent } from './components/recipientinfo/recipientinfo.component';
import { TimelyFilingReportComponent } from './components/timely-filing-report/timely-filing-report.component';
import { TokenExpirationModalComponent } from './components/token-expiration-modal/token-expiration-modal.component';
import { UnauthorizedToastComponent } from './components/unauthorized-toast/unauthorized-toast.component';
import { AddAccountToUserModalComponent } from './components/user/add-account-to-user-modal/add-account-to-user-modal.component';
import { AddAccountsToUserGridComponent } from './components/user/add-accounts-to-user-grid/add-accounts-to-user-grid.component';
import { AddCompanyToUserModalComponent } from './components/user/add-company-to-user-modal/add-company-to-user-modal.component';
import { AddGroupToUserGridComponent } from './components/user/add-group-to-user-grid/add-group-to-user-grid.component';
import { AddGroupToUserModalComponent } from './components/user/add-group-to-user-modal/add-group-to-user-modal.component';
import { ChangeUserPasswordModalComponent } from './components/user/change-user-password-modal/change-user-password-modal.component';
import { CreateUserFormComponent } from './components/user/create-user-form/create-user-form.component';
import { CreateUserModalComponent } from './components/user/create-user-modal/create-user-modal.component';
import { UserSearchModalComponent } from './components/user/user-search-modal/user-search-modal.component';
import { PasswordToggleDirective } from './directives/password-toggle.directive';
import { NgbdSortableHeaderDirective } from './directives/sort-by-header.directive';
import { NgbdSortableColumnsDirective } from './directives/sortable-headers.directive';
import { ModalComponent } from './modules/modal/modal.component';
import { TimerPipe } from './pipes/timer.pipe';
import { SidebarComponent } from './sidebar/sidebar.component';

const components = [
  TimelyFilingReportComponent,
  RecipientinfoComponent,
  TextboxFilterItemComponent,
  DropdownFilterItemComponent,
  FiltersComponent,
  LoaderComponent,
  EmptyStateComponent,
  NgbdSortableHeaderDirective,
  GroupEnrollmentsComponent,
  ProvidersGridComponent,
  ProvidersGroupGridComponent,
  CreateUserFormComponent,
  PasswordResetFromComponent,
  AddAccountsToUserGridComponent,
  AddGroupToUserGridComponent,
  UnauthorizedToastComponent,
  ClaimPanelComponent,
  QualifiersGridComponent,
  FinancialsComponent,
  //modals
  ModalComponent,
  ManageFiltersModalComponent,
  AddQuickFiltersModalComponent,
  GroupEnrollmentsModalComponent,
  AddGroupEnrollmentsModalComponent,
  AddIndependantGroupEnrollmentsModalComponent,
  ViewModifyEnrollmentsModalComponent,
  CreateProviderModalComponent,
  CreateProviderGroupModalComponent,
  EraFileInfoModalComponent,
  EditPayerModalComponent,
  EditInsuranceSetupModalComponent,
  EditClaimStatusRoutingModalComponent,
  AddProviderSetupModalComponent,
  EditProviderModalComponent,
  UserSearchModalComponent,
  AddAccountToUserModalComponent,
  TokenExpirationModalComponent,
  EditGroupEnrollmentNoteModalComponent,
  EditGroupEnrollmentCasenumberComponent,
  //formGroups
  AddressComponent,
  ContactComponent,
  StatusDatesComponent,
  BatchRemittanceComponent,
  EditGroupProcessorComponent,
  //formControls
  PracticeManagementDropdownComponent,
  CheckboxComponent,
  ShowlastFilterItemComponent,
  StatesSelectComponent,
  DatepickerComponent,
  ClaimsPanelSelectComponent,
  QualifiersComponent,
  FilterItemConfigComponent,
  RadioComponent,
  ClaimFilingIndicatorsSelectComponent,
  CardOnFileDropdownComponent,
];

const componentsDeclaredOnly = [
  CreateAccountModalComponent,
  CreateUserModalComponent,
  ChangeUserPasswordModalComponent,
  AddCompanyToUserModalComponent,
  AddGroupToUserModalComponent,
];

const directives = [NgbdSortableColumnsDirective, PasswordToggleDirective];

const pipes = [TimerPipe];

const modules = [
  CommonModule,
  NgbModule,
  NgxPermissionsModule,
  NgxMaskDirective,
  NgxMaskPipe,
];

const modulesImportedOnly = [
  RouterModule,
  DndModule,
  NgSelectModule,
  FormsModule,
  ReactiveFormsModule,
  InfiniteScrollDirective,
];

@NgModule({
  providers: [provideNgxMask(), provideHttpClient(withInterceptorsFromDi())],
  declarations: [
    ...components,
    ...componentsDeclaredOnly,
    ...directives,
    ...pipes,
    SidebarComponent,
  ],
  imports: [...modules, ...modulesImportedOnly],
  exports: [
    ...components,
    ...directives,
    ...pipes,
    ...modules,
    InfiniteScrollDirective,
    SidebarComponent,
  ],
})
export class SharedModule {}
